import { useQuery } from "react-query";
import { getMedications } from "api/customers";
import { GET_MEDICATIONS } from "@constants/reactQueryKeys";

const useGetMedications = (clientId: number | null) => {
  const { data, isLoading, refetch } = useQuery(
    [GET_MEDICATIONS, clientId],
    () => getMedications(clientId!),
    { enabled: Boolean(clientId) }
  );

  return {
    medications: data?.data ?? [],
    isMedicationsLoading: isLoading,
    refetchMedications: refetch,
  };
};

export default useGetMedications;
